import moment from 'moment';
import { meses } from '../../constants/Objects';
import { AgendaService } from '../../core/http/service/AgendaService';
import { UserRoleService } from '../../core/http/service/UserRoleService';
import AgendaMes from '../../models/core/agenda/AgendaMes';
import BaseResponse from '../../models/core/BaseResponse';
import Role from '../../models/core/userRole/Role';
 
export const FETCH_PROFISSIONAIS_AGENDA = 'FETCH_PROFISSIONAIS_AGENDA';
export const FETCH_AGENDAS_DO_PROFISSIONAL = 'FETCH_AGENDAS_DO_PROFISSIONAL';
export const FETCH_FILTER_DROPDOWN_DATA = 'FETCH_FILTER_DROPDOWN_DATA';
export const FILTER_AGENDAS_BY_NOME = 'FILTER_AGENDAS_BY_NOME';
export const FILTER_AGENDAS_BY_ROLE = 'FILTER_AGENDAS_BY_ROLE';

const sendToAnalytics = (action: string = '', error: any = null) =>{
    console.error(action, error); 
}
 
export const fetchProfissionaisAgenda = ()=>{
    const service: AgendaService = new AgendaService();
    return async (dispatch: any)=>{ 
        try{    
            const response: any = await service.getAgendasProfissionais();
            const baseResponse: any = new BaseResponse<any>().fromJSON(response.data)
            const agendas: any = []
            baseResponse.data.forEach((d: any)=>{
                agendas.push(d)
            })

            dispatch({ 
                type: FETCH_PROFISSIONAIS_AGENDA, 
                agendas: agendas
            })
        }catch(error: any){
            sendToAnalytics(error);
            throw error; 
        }
    }
};

export const fetchFilterDropdownData = ()=>{
    const perfilService: UserRoleService = new UserRoleService();
    return async (dispatch: any)=>{ 
        try{    
            const roles: any = await perfilService.getAllRoles();
            const rolesCombo: any[] = []
            roles.data.data.forEach((data: any)=>{
                const role: Role = new Role().fromJSON({...data});
                if(role.codigo !== null && role.profissionalSaude) rolesCombo.push({nome: role.nome, id: role.codigo, atribuivel: role.atribuivel })
            })

            rolesCombo.push({nome: 'Todos', id: ''})

            dispatch({ 
                type: FETCH_FILTER_DROPDOWN_DATA,
                rolesCombo: rolesCombo
            })
        }catch(error: any){
            sendToAnalytics(error);
            throw error; 
        }
    }
}

export const fetchAgendasProfissional = (profissionalId: string, perfilSaude: string)=>{
    const service: AgendaService = new AgendaService()

    return async (dispatch: any)=>{
        try{
            const retorno: AgendaMes[] = []
            const params = { 
                profissionalId: profissionalId,
                perfilSaude: perfilSaude
            }
            const response: any = await service.getAgendasProfissionalMes(params)
            const baseResponse: BaseResponse<any> = new BaseResponse().fromJSON(response.data)
            baseResponse.data.forEach((element: any)=>{
                    const object: AgendaMes = new AgendaMes().fromJSON(
                    {...element, 
                        mes: String(moment(element.data).month()+1),
                        mesDescricao: meses[moment(element.data).month()],
                    })
                retorno.push(object)
            })
            
            dispatch({ 
                type: FETCH_AGENDAS_DO_PROFISSIONAL, 
                agendas: retorno
            })
        }catch(error: any){
            sendToAnalytics(error);
            throw error; 
        }
    }
}

export const filterAgendasByProfissional = (query: string)=>{
    const service: AgendaService = new AgendaService();
    return async (dispatch: any)=>{
        try{
            const response: any = await service.getAgendasProfissionais();
            const baseResponse: any = new BaseResponse<any>().fromJSON(response.data)
            const agendas: any = []
            baseResponse.data.forEach((d: any)=>{
                agendas.push(d)
            })

            const filtrarPorNome = agendas.filter((a: any)=>{ return a.nome.toUpperCase().includes(query.toUpperCase())})

            dispatch({ 
                type: FILTER_AGENDAS_BY_NOME, 
                agendasFiltradas: filtrarPorNome
            })
        }catch(error: any){
            sendToAnalytics(error);
            throw error; 
        }
    }  
};

export const filterAgendasByRole = (role: string)=>{
    const service: AgendaService = new AgendaService();
    return async (dispatch: any)=>{
        try{
            const response: any = await service.getAgendasProfissionais();
            const baseResponse: any = new BaseResponse<any>().fromJSON(response.data)
            const agendas: any = []
            baseResponse.data.forEach((d: any)=>{
                agendas.push(d)
            })
            
            const filterByRole = agendas.filter((a: any)=>{ return a.perfilSaude === role})

            dispatch({ 
                type: FILTER_AGENDAS_BY_ROLE, 
                agendasFiltradas: role !== '' ? filterByRole : agendas
            })
        }catch(error: any){
            sendToAnalytics(error);
            throw error; 
        }
    }  
};


export const activateOrDeactivateAgendaMes = (agenda: any, profissionalInfo: any, isActivate: boolean)=>{
    const service: AgendaService = new AgendaService();
    return async (dispatch: any)=>{
        try{
            const params = {
                profissionalId: profissionalInfo.id,
                perfilSaude: profissionalInfo.perfilSaude,
                unidadeAtendimentoId: agenda.unidadeAtendimentoId,
                data: agenda.data
            }

            if(isActivate){
                await service.activateAgenda(params)
            }else{
                await service.inactivateAgenda(params)
            }

        }catch(error: any){
            sendToAnalytics(error);
            throw error; 
        }
    }
}

export const deleteAgendaMes = (id: string)=>{
    const service: AgendaService = new AgendaService();
    return async (dispatch: any)=>{
        try{
            await service.deleteAgenda(id)
        }catch(error: any){
            sendToAnalytics(error);
            throw error; 
        }
    }
}

export const activateOrDeactivateAgendaTurnoDia = (agendaId: string, turnoDiaId: string, isActivate: boolean)=>{
    const service: AgendaService = new AgendaService();
    return async (dispatch: any)=>{
        try{
            if(isActivate){
                await service.activateTurnoDia(turnoDiaId, agendaId)
            }else{
                await service.inactivateTurnoDia(turnoDiaId, agendaId)
            }

        }catch(error: any){
            sendToAnalytics(error);
            throw error; 
        }
    }
}

export const deleteAgendaTurnoDia = (agendaId: string, turnoDiaId: string)=>{
    const service: AgendaService = new AgendaService();
    return async (dispatch: any)=>{
        try{
            await service.deleteAgendaTurnoDia(turnoDiaId, agendaId)
        }catch(error: any){
            sendToAnalytics(error);
            throw error; 
        }
    }
}

export const activateOrDeactivateAgendaTurnoDiaHorario = (agendaId: string, turnoDiaId: string, turnoDiaHorarioId: string, isActivate: boolean)=>{
    const service: AgendaService = new AgendaService();
    return async (dispatch: any)=>{
        try{
            if(isActivate){
                await service.activateTurnoDiaHorario(turnoDiaId, agendaId, turnoDiaHorarioId)
            }else{
                await service.inactivateTurnoDiaHorario(turnoDiaId, agendaId, turnoDiaHorarioId)
            }

        }catch(error: any){
            sendToAnalytics(error);
            throw error; 
        }
    }
}

export const deleteAgendaTurnoDiaHorario = (agendaId: string, turnoDiaId: string, turnoDiaHorarioId: string)=>{
    const service: AgendaService = new AgendaService();
    return async (dispatch: any)=>{
        try{
            await service.deleteAgendaTurnoDiaHorario(turnoDiaId, agendaId, turnoDiaHorarioId)
        }catch(error: any){
            sendToAnalytics(error);
            throw error; 
        }
    }
}


export const createAgenda = (params: any)=>{
    const service: AgendaService = new AgendaService()
    return async (dispatch: any)=>{
        try{
            await service.register(params)
        }catch(error: any){
            sendToAnalytics(error);
            throw error; 
        }
    }
}